import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@clerk/clerk-react'
import Loading from '../../shared/components/Loading'

interface ProtectedRouteProps {
  children: ReactNode
  loadingFallback?: ReactNode
}

export default function ProtectedRoute({
  children,
  loadingFallback = <Loading />,
}: ProtectedRouteProps) {
  const { isSignedIn, isLoaded } = useAuth()
  const location = useLocation()

  if (!isLoaded) return loadingFallback
  if (!isSignedIn) {
    const returnUrl = location.pathname + location.search
    return <Navigate to={`/sign-in?redirect_url=${encodeURIComponent(returnUrl)}`} replace />
  }
  return <>{children}</>
}
